import React from "react";
import PopoverContainer from "../../../../../components/common/Popover/PopoverContainer";
import { AiOutlineWarning } from "react-icons/ai";

const ToolTipForRostering = (props) => {
  const { data, cssClass,isSmall=false } = props;

  return (
    <div>
      <PopoverContainer
        cssClass={`${cssClass} text-sm bg-gradient`}
        itemComponent={() => {}}
        toolTip={`${data}`}
      >
        <AiOutlineWarning className={`text-yellow-500 ${isSmall ? "h-3 w-3" : "h-6 w-6"}`} />
      </PopoverContainer>
    </div>
  );
};

export default ToolTipForRostering;
